import { useQuery } from "@tanstack/react-query";
import { instance } from "./instance";
import { useContext } from "react";
import { ServiceContext } from "../context/ServiceContext";

export const useFetchHomeCard = ({ interval, startDate, endDate }: { interval: string; startDate: string; endDate: string }) => {
  const { service } = useContext(ServiceContext);
  const fetchAllHomeCard = async () => {
    const response = await instance.get(
      `/admin-dashboard/home-card?interval=${interval}&startDate=${startDate}&endDate=${endDate}&activities_tab=all&network=${service}&subscription_chart_filter=all`
    );
    return response.data;
  };

  const queryApi = useQuery({
    queryKey: ["homecard", startDate, endDate], // Update the query key with start and end dates
    queryFn: fetchAllHomeCard,
    refetchOnWindowFocus: false,
  });

  return queryApi;
};

export const useFetchHomeCharts = ({ interval, startDate, endDate, activities }: { interval: string; startDate: string; endDate: string; activities: string }) => {
  const { service } = useContext(ServiceContext);

  const fetchHomeCharts = async () => {
    const response = await instance.get(
      `/admin-dashboard/home${service==="glo"?"-wsrs":""}-charts?interval=${interval}&startDate=${startDate}&endDate=${endDate}&activities_tab=${activities}&network=${service}&subscription_chart_filter=all`
    );
    return response.data;
  };

  const queryApi = useQuery({
    queryKey: ["homecharts", startDate, endDate], // Update the query key with start and end dates
    queryFn: fetchHomeCharts,
    refetchOnWindowFocus: false,
  });

  return queryApi;
};



interface SubscriptionData {
  daily_sub: number;
  weekly_sub: number;
  monthly_sub: number;
  date: string;
  endDate: string;
  startDate: string;
}

interface RevenueData {
  new_subscriber_revenue: number;
  renewals: number;
  date: string;
  endDate: string;
  startDate: string;
}

interface IHomeCharts2Response {
  success: boolean;
  message: string;
  timeline: string;
  overallArr: SubscriptionData[];
  newSubscriptionArr: SubscriptionData[];
  renewalSubscriptionArr: SubscriptionData[];
  revenueChartArr: RevenueData[];
}

export const useFetchHomeCharts2 = ({ interval, startDate, endDate, activities }: { interval: string; startDate: string; endDate: string; activities: string }) => {
  const { service } = useContext(ServiceContext);

  const fetchHomeCharts = async ():Promise<IHomeCharts2Response> => {
    const response = await instance.get(
      `/admin-dashboard/home${service==="glo"?"-sr":""}-charts?interval=${interval}&startDate=${startDate}&endDate=${endDate}&activities_tab=${activities}&network=${service}&subscription_chart_filter=all`
    );
    return response.data;
  };

  const queryApi = useQuery({
    queryKey: ["home charts2", startDate, endDate], // Update the query key with start and end dates
    queryFn: fetchHomeCharts,
    refetchOnWindowFocus: false,
  });

  return queryApi;
};
